'use client';
import React, { useState } from 'react';
import AuthorIconBox from './AuthorIconBox';
import AuthorDetailsPopup from './AuthorDetailsPopup';

const AuthorHoverContainer = ({ details }: any) => {
  const [showPopup, setShowPopup] = useState(false);
  return (
    <section
      onMouseLeave={() => setShowPopup(false)}
      onMouseEnter={() => setShowPopup(true)}
      onClick={() => setShowPopup(true)}
    >
      <section className='relative flex flex-col items-start'>
        <AuthorIconBox details={details?.author} />
        {showPopup && (
          <section className='absolute left-[-2px] top-[-2px] z-[5] animate-[scale-in-tl_.2s_ease-in] transition duration-300 ease-in-out'>
            <AuthorDetailsPopup details={details?.author} />
          </section>
        )}
      </section>
    </section>
  );
};

export default AuthorHoverContainer;
